import { PhotosClearCurrentProfilePhotosReducer } from './types';

export const photosClearCurrentProfilePhotosReducer: PhotosClearCurrentProfilePhotosReducer =
  (state) => {
    return {
      ...state,
      currentProfilePhotos: undefined,
    };
  };
